import { trackingService as trackingServiceBase } from '@bluecodecom/tracking';

import { jwtService } from '../jwt';
import { EventName, TrackingEvents } from './types';

class TrackingService {
  private static instance: TrackingService;

  public static getInstance() {
    if (!TrackingService.instance) {
      TrackingService.instance = new TrackingService();
    }

    return TrackingService.instance;
  }

  public init(id: string) {
    trackingServiceBase.init(
      process.env['NX_PUBLIC_MIXPANEL_TOKEN'],
      id,
      {},
      { app: 'terms' },
    );
  }

  public trackEvent<T extends EventName>(
    event: T,
    ...params: TrackingEvents[T] extends null
      ? [undefined?]
      : [TrackingEvents[T]]
  ) {
    trackingServiceBase.trackEvent(event, {
      ...params?.[0],
      sdk_host: jwtService.decoded.sdk_host,
    });
  }
}

const trackingService = TrackingService.getInstance();

export default trackingService;
